module.exports = __webpack_public_path__ + "static/media/avaliacoes.5eef6e76.svg";